// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__wJ4XK","col":"styles_col__1gLv8"};